import { ActiveFilterEnum, CompareFilterEnum, EnabledFilterEnum, FilterIdEnum, FilterTypeEnum } from '../enums';

import { RegularFilterConfig } from '../models';

export const COMPARE_FILTER_CONFIG: RegularFilterConfig = {
  id: FilterIdEnum.COMPARE,
  type: FilterTypeEnum.REGULAR,
  multiselectDisabled: true,
  sortValuesDisabled: true,
  emptyMeansNone: true,
  values: [
    {
      id: CompareFilterEnum.PREVIOUS_PERIOD
    },
    {
      id: CompareFilterEnum.YEAR_OVER_YEAR
    }
  ]
};

export const ENABLED_FILTER_CONFIG: RegularFilterConfig = {
  id: FilterIdEnum.ENABLED,
  type: FilterTypeEnum.REGULAR,
  multiselectDisabled: true,
  sortValuesDisabled: true,
  values: [
    {
      id: EnabledFilterEnum.ENABLED
    },
    {
      id: EnabledFilterEnum.DISABLED
    }
  ]
};

export const ACTIVE_FILTER_CONFIG: RegularFilterConfig = {
  id: FilterIdEnum.ACTIVE,
  type: FilterTypeEnum.REGULAR,
  multiselectDisabled: true,
  sortValuesDisabled: true,
  values: [
    {
      id: ActiveFilterEnum.ACTIVE
    },
    {
      id: ActiveFilterEnum.INACTIVE
    }
  ]
};
